export default __webpack_public_path__ + "static/media/master-card-white.8fde3587.svg";